module.exports = __webpack_public_path__ + "img/474843_CECEC4_898883_A3A3A4-256px.88381b06.png";